import React from 'react'
import { IndexRedirect, IndexRoute, Redirect, Route } from 'react-router'

import Admin from './Admin'
import AdminLeaderboardDefinitions from './AdminLeaderboardDefinitions'
import AdminLogin from './AdminLogin'
import AdminReports from './AdminReports'
import Container from './Container'
import CustomSupporterPage from './CustomSupporterPage'
import CustomSupporterPageAdmin from './CustomSupporterPageAdmin'
import CustomSupporterPageClaim from './CustomSupporterPageClaim'
import CustomSupporterPageLogin from './CustomSupporterPageLogin'
import CustomTagPage from './CustomTagPage'
import CustomTeamPage from './CustomTeamPage'
import Home from './Home'
import Page from './Page'
import Preview from './Preview'
import StravaConnect from './StravaConnect'

export default (
  <Route path='/' component={Container}>
    <IndexRoute component={Home} />
    <Route path='admin' component={Admin}>
      <IndexRedirect to='login' />
      <Route path='login' component={AdminLogin} />
      <Route path='reports' component={AdminReports} />
    </Route>
    <Route path='admin/leaderboard-definitions' component={AdminLeaderboardDefinitions} />
    <Route path='preview' component={Preview} />
    <Route path='fundraising/:slug/connect' component={StravaConnect} />
    <Route path='fundraising/:slug' component={CustomSupporterPage}>
      <Route path='admin' component={CustomSupporterPageAdmin} />
      <Route path='claim' component={CustomSupporterPageClaim} />
      <Route path='login' component={CustomSupporterPageLogin} />
    </Route>
    <Redirect from='fundraising/teams/:slug' to='teams/:slug' />
    <Route path='teams/:slug' component={CustomTeamPage} />
    <Route path=':tag/:slug' component={CustomTagPage} />
    <Route path=':slug' component={Page} />
  </Route>
)
